import { DOMAIN } from "consts";
import Cookies from "js-cookie";

export const setSessionCookies = (refreshToken, accessToken) => {
  Cookies.set("accessToken", accessToken, {
    path: "/",
    domain: DOMAIN,
    secure: true,
    sameSite: "strict",
  });
  Cookies.set("refreshToken", refreshToken, {
    path: "/",
    domain: DOMAIN,
    secure: true,
    sameSite: "strict",
  });
};
